import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faBoxArchive, faCheck, faGraduationCap, faInbox, faShieldHalved, faSparkles } from '@fortawesome/pro-solid-svg-icons'
import { EmptyState } from '../../../../shared/empty-state/empty-state'

// Each tab's empty inbox (owner 2026-10-24), the shared zero state
// (shared/empty-state) with a small illustration in its icon's place: a
// large soft disc holding the tab's picture, a satellite badge and a couple
// of floating dots. Decorative, in the workspace's tokens, still under
// reduced motion.

const ART = {
  all: { main: faBell, badge: faGraduationCap, second: faShieldHalved },
  unread: { main: faCheck, badge: faSparkles },
  archived: { main: faBoxArchive, badge: faInbox }
}

export const EMPTY = {
  all: { title: 'No notifications yet', message: "When a course is shared with you, an upload finishes or someone signs in to your account, you'll see it here." },
  unread: { title: "You're all caught up", message: 'Nothing new since you last looked.' },
  archived: { title: 'Nothing archived', message: "Archive a notification to tidy your inbox. It'll wait for you here." }
}

const illustration = kind => {
  const art = ART[kind] || ART.all
  return () =>
    <span className={`nt-art nt-art-${kind}`} data-testid={`inbox-empty-art-${kind}`}>
      <span className="nt-art-disc"><FontAwesomeIcon icon={art.main} /></span>
      <span className="nt-art-badge"><FontAwesomeIcon icon={art.badge} /></span>
      {art.second && <span className="nt-art-badge nt-art-badge-2"><FontAwesomeIcon icon={art.second} /></span>}
      <span className="nt-art-dot nt-art-dot-1" />
      <span className="nt-art-dot nt-art-dot-2" />
    </span>
}

const ARTWORK = { all: illustration('all'), unread: illustration('unread'), archived: illustration('archived') }

export const InboxEmpty = ({ filter }) => {
  const words = EMPTY[filter] || EMPTY.all
  return <EmptyState className="nt-empty" Icon={ARTWORK[filter] || ARTWORK.all} title={words.title} message={words.message} testID={`inbox-empty-${filter}`} />
}
